module.exports = __webpack_public_path__ + "static/img/fullscreen-image_our-awards.a81311b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/fullscreen-image_our-awards.png
// module id = UzeL
// module chunks = 0